
import { useEffect, useState } from "react";

import { useDispatch } from "react-redux";

import { useParams } from "react-router";

import { Box, Button, Card, CardContent, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, Tooltip, Typography } from "@mui/material";

import { AiOutlineFileText, AiOutlineFileProtect } from "react-icons/ai";

import moment from "moment";

import { usePages } from "../../../hooks/usePages";

import { TablePaginationActions } from "../../../helpers/TablePaginationActions";

import { openSnackbar } from "../../../store/slices/SnackbarSlice";

import { TableTheadStyle, TablePaddingStyle } from "../../../styles/TableStyle";
import { DialogContentStyle, DialogActionsStyle } from "../../../styles/DialogStyle";

import { Layout } from "../../../components/Layout"
import { InfoField } from "../../../components/InfoField";
import { BoxProcesoCancelado } from "../../../components/BoxProcesoCancelado";
import { BoxProcesoTerminado } from "../../../components/BoxProcesoTerminado";
import { BoxProcesoNoEncontrado } from "../../../components/BoxProcesoNoEncontrado";
import { CircularProgressIndicator } from "../../../components/CircularProgressIndicator";

import { DialogDocumento } from "../../../dialogs/DialogDocumento";

import { DetalleListadoEnvio, FinalizarListadoEnvio, GenerarListadoEnvio } from "../../../connections/notificaciones/ListadoEnvioConnection";

import { defaultDetalleListadoEnvioResponse, DetalleListadoEnvioResponse, ListadoEnvioNotificacionProps } from "../../../interfaces/notificaciones/ListadoEnvioInterface";

export const GenerarListadoEnvioPage = () => {

    const { Id } = useParams();

    const dispatch = useDispatch();

    const [rows, setRows] = useState<ListadoEnvioNotificacionProps[]>( [] );
    const [rowsAll, setRowsAll] = useState( false );

    const [loading, setLoading] = useState( true );
    const [loadingGenerar, setLoadingGenerar] = useState( false );
    const [loadingFinalizar, setLoadingFinalizar] = useState( false );

    const [procesoTerminado, setProcesoTerminado] = useState( false );
    const [procesoCancelado, setProcesoCancelado] = useState( false );
    const [procesoNoEncontrado, setProcesoNoEncontrado] = useState( false );
    const [mensajeAsignacion, setMensajeAsignacion] = useState( '' );

    const [listadoEnvio, setListadoEnvio] = useState<DetalleListadoEnvioResponse>( defaultDetalleListadoEnvioResponse );

    const [documento, setDocumento] = useState( '' );
    const [openDocumento, setOpenDocumento] = useState( false );

    const [documentoListadoEnvio, setDocumentoListadoEnvio] = useState( '' );

    const [openDialogConfirmacion, setOpenDialogConfirmacion] = useState( false );
    const [openDialogConfirmacionFinalizar, setOpenDialogConfirmacionFinalizar] = useState( false );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } = usePages(10);

    const handleGenerarVisualizar = () => {

        if ( documentoListadoEnvio ) {

            setDocumento( documentoListadoEnvio );
            setOpenDocumento( true );

        }
        else {

            setOpenDialogConfirmacion( true );

        }

    }

    const handleGenerarListadoEnvio = async () => {

        setLoadingGenerar( true );

        await GenerarListadoEnvio({ idListadoEnvio: Id ?? '', notificaciones: rows }).then(resp => {

            setTimeout(() => {

                const { documento, success, message } = resp;

                if ( success ) {

                    setDocumentoListadoEnvio( documento );

                    setDocumento( documento );
                    setOpenDocumento( true );

                    setLoadingGenerar( false );
                    setOpenDialogConfirmacion( false );
                    setRows( rows.filter( ({ selected }) => selected === true ) );

                }
                else {

                    dispatch( openSnackbar({ message: message, variant: 'error' }) );
                    setLoadingGenerar( false );

                }

            }, 700);

        });
    }

    const handleFinalizar = async () => {

        setLoadingFinalizar( true );

        await FinalizarListadoEnvio( Id ?? '' ).then( resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    setLoadingFinalizar( false );
                    setOpenDialogConfirmacionFinalizar( false )
                    setProcesoTerminado( true );

                    setMensajeAsignacion( 'No se tienen actividades pendientes para este trámite' );

                }
                else {

                    dispatch( openSnackbar({ message: message, variant: 'error' }) );
                    setLoadingFinalizar( false );

                }

            }, 700);

        });

    }

    const handleSelectAll = ( value: boolean ) => {

        setRows( rows.map( elem => ({ ...elem, selected: value }) ) );
        setRowsAll( value );

    }

    const handleSelectRow = ( value: boolean, id: number ) => {

        setRows( rows.map(elem =>
            elem.idNotificacion === id ? { ...elem, selected: value } : elem
        ));

    }

    useEffect(() => {

        async function Obtener() {

            setLoading( true );

            await DetalleListadoEnvio( Id ?? '' ).then(resp => {

                const { success, usuarioAsignado, asignadoMismoUsuario, documento, idEstatus, notificaciones } = resp;

                setTimeout(() => {

                    if ( success ) {

                        if ( idEstatus === 3 ) {

                            setMensajeAsignacion( 'No se tienen actividades pendientes para este trámite' );
                            setProcesoTerminado( true );
                            setLoading( false );

                        }
                        else if ( idEstatus === 4 ) {

                            setProcesoCancelado( true );
                            setLoading( false );

                        }
                        else if ( !asignadoMismoUsuario ) {

                            setMensajeAsignacion( `La siguiente actividad se asignó a ${ usuarioAsignado }` );
                            setProcesoTerminado( true );
                            setLoading( false );

                        }
                        else if ( asignadoMismoUsuario && idEstatus !== 51 ) {

                            setMensajeAsignacion( 'La siguiente actividad se encuentra en tu bandeja' );
                            setProcesoTerminado( true );
                            setLoading( false );

                        }
                        else if ( asignadoMismoUsuario && idEstatus === 51 ) {

                            setListadoEnvio( resp );
                            setDocumentoListadoEnvio( documento );
                            setRows( notificaciones.map( n => ({ ...n, selected: false }) ) );

                            setLoading( false );

                        }

                    }
                    else {

                        setProcesoNoEncontrado( true );
                        setLoading( false );

                    }

                }, 700);

            });

        }

        if ( Id ) {
            Obtener();
        }

    }, [ Id ])

    return (
        <Layout breadcrumbs={ [{ text: 'Listado de envío' }, { text: 'Generar listado de envío' }] } backgroundPaper={( procesoTerminado || procesoCancelado || procesoNoEncontrado )}>

            {
                loading
                ?
                    <Box sx={{ textAlign: 'center', alignItems: 'center', minHeight: 580 }}>
                        <CircularProgressIndicator mt={ 30 } />
                    </Box>
                :
                    ( procesoTerminado || procesoCancelado || procesoNoEncontrado )
                    ?
                        procesoNoEncontrado
                        ?
                            <BoxProcesoNoEncontrado />
                        :
                            procesoCancelado
                            ?
                                <BoxProcesoCancelado />
                            :
                                <BoxProcesoTerminado message={ mensajeAsignacion } />
                    :
                        <>

                            <Grid container spacing={ 3 }>

                                <Grid size={{ md: 12, xs: 12 }}>

                                    <Card>

                                        <CardContent sx={{ p: 3 }}>

                                            <Grid container spacing={ 3 }>

                                                <Grid size={ 12 }>

                                                    <Grid container spacing={ 3 }>

                                                        <Grid size={{ md: 4, xs: 12 }}>

                                                            <InfoField
                                                                label="Número de seguimiento"
                                                                value={ `GLEN-${ listadoEnvio.idListadoEnvio }` }
                                                                fontSize={ 22 }
                                                            />

                                                        </Grid>

                                                        <Grid size={{ md: 4, xs: 12 }}>

                                                            <InfoField
                                                                label="Fecha"
                                                                value={ listadoEnvio.fecha ? moment( listadoEnvio.fecha ).format( 'DD-MM-YYYY hh:mm a' ) : '' }
                                                                fontSize={ 22 }
                                                            />

                                                        </Grid>

                                                    </Grid>

                                                </Grid>

                                                <Grid size={{ md: 12, xs: 12 }}> <Divider /> </Grid>

                                                <Grid size={{ md: 8, xs: 12 }}></Grid>

                                                <Grid size={{ md: 4, xs: 12 }}>

                                                    <Grid container spacing={ 3 }>

                                                        <Grid size={{ md: 8, xs: 12 }}>

                                                            <Button
                                                                fullWidth
                                                                color="secondary"
                                                                variant="outlined"
                                                                onClick={ handleGenerarVisualizar }
                                                                disabled={ documentoListadoEnvio === '' && rows.filter( ({ selected }) => selected === true ).length === 0 }
                                                            >

                                                                { documentoListadoEnvio !== '' ? 'Visualizar listado de envío' : 'Generar listado de envío' }

                                                            </Button>

                                                        </Grid>

                                                        <Grid size={{ md: 4, xs: 12 }}>

                                                            <Button
                                                                fullWidth
                                                                variant="contained"
                                                                disabled={ !documentoListadoEnvio }
                                                                onClick={ () => setOpenDialogConfirmacionFinalizar( true ) }
                                                            >
                                                                Finalizar
                                                            </Button>

                                                        </Grid>

                                                    </Grid>

                                                </Grid>

                                            </Grid>

                                        </CardContent>

                                    </Card>

                                </Grid>

                                <Grid size={{ md: 12, xs: 12 }}>

                                    <TableContainer sx={{ borderRadius: 3 }} component={ Paper }>

                                        <Table>

                                            <TableHead sx={{ ...TableTheadStyle }}>

                                                <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold' }}>Fecha</TableCell>
                                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold' }}>Referencia</TableCell>
                                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '30%', fontWeight: 'bold' }}>Persona y domicilio a notificar</TableCell>
                                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold' }}>Tipo de notificación</TableCell>
                                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold' }}>Documento a notificar</TableCell>

                                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold', textAlign: 'end' }}>

                                                    {
                                                        !documentoListadoEnvio
                                                        &&
                                                            <Tooltip title='Seleccionar todo'>

                                                                <Checkbox
                                                                    checked={ rowsAll }
                                                                    onChange={ (e) => handleSelectAll( e.target.checked ) }
                                                                    sx={{ bgcolor: 'white', borderRadius: 2, ':hover': { bgcolor: 'white' } }}
                                                                />

                                                            </Tooltip>
                                                    }

                                                    </TableCell>

                                                </TableRow>

                                            </TableHead>

                                            <TableBody>

                                            {
                                                (   rowsPerPage > 0
                                                    ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                    : rows
                                                ).map( ( { idNotificacion, fechaNotificacion, referencia, otraReferencia, personaNotificar, tipoParte, domicilio, tipoNotificacion, tipoAcuerdo, subTipoAcuerdo, acuerdo, cedulaNotificacion, selected }, index ) => (

                                                    <TableRow key={ index } >

                                                        <TableCell>

                                                            <Typography variant='subtitle1'>
                                                                { moment( fechaNotificacion ).format( 'DD-MM-YYYY' ) }
                                                            </Typography>

                                                            <Typography variant='caption' color='text.secondary'>
                                                                { moment( fechaNotificacion ).format( 'hh:mm a' ) }
                                                            </Typography>

                                                        </TableCell>

                                                        <TableCell>

                                                            <Typography variant="subtitle1">
                                                                <strong>{ referencia }</strong>
                                                            </Typography>

                                                            { otraReferencia && <Typography variant="subtitle2" fontWeight={ 'normal' } fontSize={ 14 }>{ otraReferencia }</Typography> }

                                                        </TableCell>

                                                        <TableCell>

                                                            <Typography variant="subtitle1">
                                                                <strong>{ personaNotificar.toUpperCase() }</strong> ({ tipoParte })
                                                            </Typography>
                                                            <Typography variant="subtitle2" fontWeight={ 'normal' } fontSize={ 12 }>{ domicilio }</Typography>

                                                        </TableCell>

                                                        <TableCell> { tipoNotificacion } </TableCell>

                                                        <TableCell>
                                                            {
                                                                subTipoAcuerdo
                                                                ?
                                                                    <>
                                                                        <Typography variant="subtitle1" fontWeight={ 'bold' }>{ tipoAcuerdo }</Typography>
                                                                        <Typography variant="subtitle2" fontWeight={ 'normal' } fontSize={ 14 }>({ subTipoAcuerdo })</Typography>
                                                                    </>
                                                                :
                                                                    <Typography variant="subtitle1" fontWeight={ 'bold' }>{ tipoAcuerdo }</Typography>
                                                            }
                                                        </TableCell>

                                                        <TableCell sx={{ textAlign: 'end' }}>

                                                            <Tooltip title='Visualizar documento a notificar'>

                                                                <IconButton color="primary" onClick={ () => { setDocumento( acuerdo ); setOpenDocumento( true ); }}>
                                                                    <AiOutlineFileText fontSize={ 28 } />
                                                                </IconButton>

                                                            </Tooltip>

                                                            {
                                                                cedulaNotificacion
                                                                &&
                                                                    <Tooltip title='Visualizar cédula de notificación'>

                                                                        <IconButton color="primary" sx={{ ml: 1 }} onClick={ () => { setDocumento( cedulaNotificacion ); setOpenDocumento( true ); }}>
                                                                            <AiOutlineFileProtect fontSize={ 28 } />
                                                                        </IconButton>

                                                                    </Tooltip>
                                                            }

                                                            {
                                                                !documentoListadoEnvio
                                                                &&
                                                                    <Tooltip title='Seleccionar'>

                                                                        <Checkbox
                                                                            checked={ selected }
                                                                            onChange={ ( e ) => handleSelectRow( e.target.checked, idNotificacion ) }
                                                                        />

                                                                    </Tooltip>
                                                            }

                                                        </TableCell>

                                                    </TableRow>

                                                ))
                                            }

                                            {
                                                rows.length === 0
                                                &&
                                                    <TableRow>
                                                        <TableCell
                                                            colSpan={ 8 }
                                                            align="center"
                                                        >
                                                            <Typography variant="caption" color='secondary'> No se encontraron registros </Typography>
                                                        </TableCell>
                                                    </TableRow>
                                            }

                                            </TableBody>

                                            <TableFooter>

                                                <TableRow>

                                                    <TableCell colSpan={ 2 }>
                                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> Total de registros: { rows.length } </Typography>
                                                    </TableCell>

                                                    <TablePagination
                                                        rowsPerPageOptions={ [5, 10, 15, 25, 50, 75, 100, 150, 200, 500] }
                                                        colSpan={ 8 }
                                                        count={ rows.length }
                                                        rowsPerPage={ rowsPerPage }
                                                        page={ page }
                                                        onPageChange={ handleChangePage }
                                                        onRowsPerPageChange={ handleChangeRowsPerPage }
                                                        ActionsComponent={ TablePaginationActions }
                                                        labelRowsPerPage={ 'Filas por página:' }
                                                        labelDisplayedRows={
                                                            ({ from, to, count }) => {
                                                            return '' + from + '-' + to + ' de ' + count
                                                            }
                                                        }
                                                    />

                                                </TableRow>

                                            </TableFooter>

                                        </Table>

                                    </TableContainer>

                                </Grid>

                            </Grid>

                            <DialogDocumento
                                documento={ documento }
                                openDialog={ openDocumento }
                                handleCloseDialog={ () => setOpenDocumento( false ) }
                            />

                            <Dialog
                                fullWidth
                                maxWidth='xs'
                                open={ openDialogConfirmacion }
                                onClose={ () => {} }
                            >

                                <DialogTitle>
                                    Confirmación
                                </DialogTitle>

                                <DialogContent sx={ DialogContentStyle }>

                                    <DialogContentText>
                                        ¿Desea generar el listado de envío?
                                    </DialogContentText>

                                </DialogContent>

                                <DialogActions sx={ DialogActionsStyle }>

                                    <Button color='secondary' disabled={ loadingGenerar } onClick={ () => setOpenDialogConfirmacion( false ) }> Cancelar </Button>
                                    <Button loading={ loadingGenerar } onClick={ handleGenerarListadoEnvio } variant='contained' > Aceptar </Button>

                                </DialogActions>

                            </Dialog>

                            <Dialog
                                fullWidth
                                maxWidth='xs'
                                open={ openDialogConfirmacionFinalizar }
                                onClose={ () => {} }
                            >

                                <DialogTitle>
                                    Confirmación
                                </DialogTitle>

                                <DialogContent sx={ DialogContentStyle }>

                                    <DialogContentText>
                                        ¿Desea finalizar la generación del listado de envío?
                                    </DialogContentText>

                                </DialogContent>

                                <DialogActions sx={ DialogActionsStyle }>

                                    <Button color='secondary' disabled={ loadingFinalizar } onClick={ () => setOpenDialogConfirmacionFinalizar( false ) }> Cancelar </Button>
                                    <Button loading={ loadingFinalizar } onClick={ handleFinalizar } variant='contained' > Aceptar </Button>

                                </DialogActions>

                            </Dialog>

                        </>
            }

        </Layout>
    )
}
